const R_MI = 3958.8;
const hav = (a, b) => {
  const toR = (d) => (d * Math.PI) / 180;
  const dLat = toR(b[0] - a[0]);
  const dLng = toR(b[1] - a[1]);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toR(a[0])) * Math.cos(toR(b[0])) * Math.sin(dLng / 2) ** 2;
  return 2 * R_MI * Math.asin(Math.sqrt(h));
};

// Client-side estimate for a manually reordered route (mirrors backend estimate mode).
export const estimateRoute = (order) => {
  let d = 0;
  for (let i = 1; i < order.length; i++) {
    const a = order[i - 1];
    const b = order[i];
    if (a.lat != null && b.lat != null) d += hav([a.lat, a.lng], [b.lat, b.lng]);
  }
  const road = d * 1.3;
  return { distance_mi: Math.round(road * 10) / 10, drive_min: Math.round((road / 32) * 60) };
};

// Drive minutes from the previous stop (or origin) into stop i; manual orders fall back to estimate.
export const legMinutes = (order, i, manual) => {
  if (!manual && order[i].leg_min != null) return order[i].leg_min;
  if (i === 0) return order[0].leg_min || 0;
  const a = order[i - 1];
  const b = order[i];
  if (a.lat == null || b.lat == null) return 0;
  return Math.round((hav([a.lat, a.lng], [b.lat, b.lng]) * 1.3 / 32) * 60);
};

// ETA list: [{arrive: Date, depart: Date}] given departure "HH:MM" on a date and on-site minutes.
export const arrivalTimes = (order, date, departHHMM, onSiteMin, manual) => {
  if (!departHHMM) return [];
  let t = new Date(`${date}T${departHHMM}:00`);
  return order.map((o, i) => {
    t = new Date(t.getTime() + legMinutes(order, i, manual) * 60000);
    const arrive = t;
    const onSite = o.service_min != null && o.service_min > 0 ? o.service_min : onSiteMin;
    t = new Date(t.getTime() + onSite * 60000);
    return { arrive, depart: t, on_site: onSite };
  });
};

export const fmtTime = (d) =>
  d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

// Stable id for a scheduled stop — must match the backend _event_key().
export const stopKey = (e) =>
  [e.job_id || e.project_id || "", e.kind || "", e.stop_id || e.task_id || ""].join("|");
